import React from "react";
import { Box, TextareaAutosize, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',  // 幅を100%に設定
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  content: {
    '& p': {
      marginBottom: theme.spacing(2),
      textAlign: 'left',
    }
  }
}));

const PrivacyPolicySeller = () => {
  const classes = useStyles();
  const text = `
個人情報の取り扱いについて
ピッタプット運営会社の株式会社SORA（以下「当社」）は、お預かりした個人情報において、次のように管理し保護に努めて参ります。つきましては、本内容をご理解いただき、ご同意の程お願い申し上げます。

＜個人情報保護方針＞
当社は、お客様の個人情報保護、個人情報の適切な取り扱いを重要かつ社会的責務であると考え、以下の通り「個人情報保護方針」を定め、適切に運用致します。
1. 当社の事業および規模を考慮した適切な個人情報の取得、利用及び提供に関する社内規程を遵守します。
2. 当社が保有する個人情報に関して適用される法令、国が定める指針その他の規範を遵守いたします。
3. 個人情報の漏えい、滅失又はき損などに対して、防止及び是正対策を実施します。
4. 個人情報の取扱いに関するお客様からのご意見・ご相談・苦情等に対して適切に対応します。
5. 当社は、個人情報保護マネジメントシステムを確立し、定期的に見直し改善に努めます。
6. 取得した個人情報は後述する利用目的の範囲内でのみ利用し、これらの利用目的以外で利用する際は利用者に対し事前に確認または同意を得ます。

＜収集する個人情報と取得方法＞
ピッタプット（以下、本サービス）では出品者登録に際して以下の個人情報をお客様より入力していただき、それらを個人情報として扱います。
・氏名（法人名）
・メールアドレス
・郵便番号
・住所
・電話番号

＜個人情報の利用目的＞
・ご相談・お問い合わせへの適切な対応
・当社サービスの改善に役立てるため
・購入者の個人情報を提供する際に提供先として記録を作成するため

＜個人情報の第三者提供＞
お客様の個人情報について、お客様本人の同意を得ずに、本サービス利用企業などの第三者に開示することは、原則いたしません。ただし以下の場合は、関係法令に反しない範囲で、お客様の同意なくお客様の個人情報を開示することがあります。

1. お客様が第三者に不利益を及ぼすと当社が判断した場合。
2. 人の生命、身体または財産の保護のために必要がある場合であって、お客様本人の同意を得ることが困難である場合。
3. 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様本人の同意を得ることが困難である場合。
4. 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合。
5. 裁判所、検察庁、警察、弁護士会、消費者センターまたはこれらに準じた権限を有する機関から、個人情報についての開示を求められた場合。
6. お客様本人から明示的に第三者への開示または提供を求められた場合。
7. 法令により開示または提供が許容されている場合。

＜改定＞
当社はプライバシーポリシーの内容を定期的に見直し、必要に応じ全部又は一部改定することがあります。この場合、変更後のプライバシーポリシーについては、当社が別途定める場合を除いて、本サイトに掲載した時から効力を生じるものとします。

制定：2020年7月3日`;

  return (
    <Paper className={classes.paper}>
      <Box className={classes.content}>
        <TextareaAutosize
          id="privacyPolicySeller"
          value={text}
          readOnly
          minRows={10}
          style={{
            width: "100%",
            fontSize: "0.8em",
            lineHeight: "1.2em",
            padding: "8px",
            backgroundColor: "#f9f9f9",
            border: "1px solid #ddd",
            borderRadius: "4px",
          }}
        />
      </Box>
    </Paper>
  );
};

export default PrivacyPolicySeller;